import useCommonCustomerQueryCaa from "@repo/shopify/queries/useCustomerQueryCaa";

import useLanguage from "@hooks/useLanguage";

import { caaRequest } from "@lib/caaClient";

import { useLayoutStore } from "@store/layout";

export default function useCustomerCaa() {
  const { lang } = useLanguage();
  const { openToast } = useLayoutStore();

  return useCommonCustomerQueryCaa({ request: caaRequest, lang, openToast });
}
